export function useOneTimePrice(offer, category = null) {
    let oneTimePrice = 0

    const categoryPrice = category ? parseFloat(category) : parseFloat(offer.monthly_price_category);
    const deviceDiscount = parseFloat(offer.total_discount_device)
    const deviceValue = parseFloat(offer.device_value) - parseFloat(offer.discount) + deviceDiscount
    const pricePerYear = offer.subscription.duration * categoryPrice

    const loanPrice = parseFloat(offer.total_loan) > 0 && categoryPrice
        ? categoryPrice * offer.subscription.duration
        : parseFloat(offer.total_loan)

    oneTimePrice = parseFloat(offer.device_price)
        + (parseFloat(offer.monthly_price_category) - categoryPrice)
        * offer.subscription.duration

    if (offer.family.is_business && !loanPrice && !categoryPrice && offer.total_loan) {
        oneTimePrice = deviceValue - deviceDiscount
    } else if (offer.family.is_business && loanPrice) {
        oneTimePrice = (deviceValue * 1.21) - (deviceDiscount * 1.21) - pricePerYear
    }

    if (!offer.subscription.has_device && offer.cash_back) {
        oneTimePrice -= offer.cash_back
    }

    oneTimePrice = Math.round(oneTimePrice * 100) / 100

    if (Math.abs(oneTimePrice) <= 0.05) {
        return 0;
    }

    return oneTimePrice
}
